export default "__VITE_ASSET__BmkMV70h__"